import React from 'react';
import NavBar from '../../../components/common/navbar';
import SideBar from '../../../components/modules/left_sidebar';
import ReceitasEmCobranca from './ReceitasEmCobranca';
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import services from '../../../services';
const queryString = require('query-string');
var moment = require('moment')
const Administration = false;
/*
Formato de solicitação padrão para todas as APIs de listagem   
*/
const listdefaultRequest = {
    "Filters": {
        "entity_id": null,
        "start_date": "2020-08-11",
        "end_date": "2020-09-21",
        "is_paid": null,
        "type": null,
        "local": null,
        "is_doc_generated": null,
        invoice_id: null,
    },
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 1,
    "PageSize": 1
}

/* Array de configurações estáticas da página*/
const optionMenuArray = [
    {
        // main: "Receitas em cobrança",
        sub_menu: [
            {
                //display: "-Receitas em cobrança",
                linkData: {
                    filters: {
                        Tabs: {
                            Período: [
                                {
                                    key: 'RangePicker',
                                    displayKey: "intervalo de datas",
                                    inputType: "RangePicker"
                                }
                            ]
                        },
                        checkbox: []
                    },
                    columnkeyMap: {
                        "no": "Numero do documento",
                        "nome": "Entidade",
                        "document_type": "Tipo de fatura",
                        "valor_cativo": "Valor",
                        "issue_date_time": "Data do documento"
                    },
                    actionbuttons: { File: true },// Redirect: "Emitir Fatura",
                    listApilink: "/Revenue/GetInvoiceList",
                    listdefaultRequest: listdefaultRequest,
                    requestMethod: "post",
                    navbarOptionsYear: false,
                    nevdropdown: ["Abertura", "Fecho"],
                    nevdroplabel: "",
                    nevdropplaceholder: "Aberta",
                    prevPageName: "Recibos de Adiantamento",
                    prevPageLink: "revenue_receitas",
                    // OpenAndCloseCashier: true,
                    TitleBartitle: "Tesouraria",
                    currentPath: "revenue_receitas",
                    nevOptionLinks: [
                        {
                            name: 'Emissão de Recibos de Adiantamento',
                            url: 'revenue_receitas'
                        },
                        {
                            name: 'Consulta de Conta corrente',
                            url: 'revenue_conta'
                        },
                        {
                            name: 'Faturas',
                            url: 'revenue_faturas'
                        },
                        {
                            name: 'Recibos de Adiantamento',
                            url: 'recabo_de_adiantamento'
                        },
                        {
                            name: 'Faturas Em Cobrança',
                            url: 'revenue_faturas'
                        }
                    ],
                    TitleBarlogo: "auditing",
                    // groupfield: [{ field: 'Tipo receita' } ]
                }
            }
        ]
    }
]


class RecaboDeAdiantamento extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
    }

    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */

    setLinkDataMethod = () => {
        let mainIndex = 0;
        let subIndex = 0;
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.m) {
            mainIndex = parsed.m;
        }
        if (parsed.s) {
            subIndex = parsed.s;
        }
        let selectOption = optionMenuArray[mainIndex].sub_menu[subIndex];
        let selectedMainOption = optionMenuArray[mainIndex]
        let year = new Date();
        year = year.getFullYear();
        console.log("selectOption", selectOption);
        return {
            year: year,
            noOption: true,
            popUpForm: null,
            selectedtitelotion: selectOption.display,
            selectedMainOption: selectedMainOption.main,
            linkData: selectOption.linkData,
            trans_methods: null,
            lastworkingdate: null,
            Tab: null,
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            currency_list: [],
            tax_list: [],
            TransMethods_list: [],
            parsed: parsed
        }
    }

    /*  Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (mainIndex, subIndex) => {
        console.log("selectOption,mainIndex,subIndex", mainIndex, subIndex)
        window.location = "/revenue_receitas?m=" + mainIndex + "&s=" + subIndex;
        return;
    }

    /*  Para fechar pop-up  */

    closePopup = () => {
        $(".left-popup").trigger('click');
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="dashboard">
                <NavBar date={new Date()} linkData={this.state.linkData} noOption={this.state.noOption} updateNavDropdown={(_row) => this.updateNavDropdown(_row)} />
                <SideBar Administration={Administration} />

                <div className="container-fluid">
                    <ReceitasEmCobranca
                        selectedMainOption={this.state.selectedMainOption}
                        date={new Date()}
                        parsed={this.state.parsed}
                        changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                        optionMenuArray={optionMenuArray}
                        linkData={this.state.linkData}
                        trans_methods={this.state.trans_methods}
                        selectedtitelotion={this.state.selectedtitelotion}
                        tab={"Revenue_receitas"}
                    />
                </div>
                <button type="hidden" data-toggle="modal" data-target="#popup-modal" className="modelpopup"></button>
                <div className="modal left-popup" id="popup-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>

            </div>

        )
    }
}


export default RecaboDeAdiantamento;